import VideosByPodcastTable from './VideosByPodcast';

export default VideosByPodcastTable;
